<template>
  <div>
    <div class="title">
      <span style="cursor: pointer" @click="$router.go(-1)">订单管理</span>
      > <span>退货申请详情</span>
    </div>
    <div>
      <div class="order_Box">
        <div style="margin-bottom:40px">退货商品</div>
        <el-table ref="table" :data="orderinformation" :summary-method="getummaries" border show-summary style="width: 100%" :header-cell-style="{ background: '#F5F6FA' }">
          <el-table-column align="center" prop="order_child_goods_sn" label="商品订单号"  width="200"> </el-table-column>
          <el-table-column align="center" prop="title" label="商品名称"> </el-table-column>
          <el-table-column align="center" prop="sku_id" label="商品ID" width="70"> </el-table-column>
          <el-table-column align="center" label="商品规格">
            <template>
              <div v-for="(item, index) in orderRowinfo" :key="index" style="display: flex; flex-direction: column">
                <div>
                  <span>{{ item.name }} :</span><span>{{ item.value }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sku_num" label="数量" width="90"> </el-table-column>
          <el-table-column align="center" prop="price" label="单价" width="90"> </el-table-column>
          <el-table-column align="center" prop="price_yh_all" label="优惠金额" width="90"> </el-table-column>
          <el-table-column align="center" prop="price_card" label="礼品卡支付金额" width="90"> </el-table-column>
          <el-table-column align="center" prop="price_account" label="余额" width="90"> </el-table-column>
          <el-table-column align="center" prop="price_pay" label="实付金额" width="90"> </el-table-column>
        </el-table>
        <div style="margin-top:40px">
          <div>订单信息</div>
          <div v-for="(item, index) in RefundInformation" :key="index">
            <div class="order_information" >
            <div class="order_column">
              <div>
                <span class="order_key">申请单号</span>
                <span>{{ item.id }}</span>
              </div>
              <div>
                <span class="order_key">用户账号</span>
                <span>{{ item.user_name }}</span>
              </div>
              <div>
                <span class="order_key">订单金额</span>
                <span>{{ item.price_order }}</span>
              </div>
              <div>
                <span class="order_key">退货类型</span>
                <span>{{ item.refund_type === 1 ? "退款" : "退货" }}</span>
              </div>
              
            </div>
            <div class="order_column">
              <div>
                <span class="order_key">订单编号</span>
                <span>{{ item.order_child_sn }}</span>
              </div>
              <div>
                <span class="order_key">联系方式</span>
                <span>{{ item.mobile_phone }}</span>
              </div>
              <div>
                <span class="order_key">退货金额</span>
                <span>{{ item.price_pay }}</span>
              </div>
              <div>
                <span class="order_key">申请状态</span>
                <span>{{ item.status == 1 ? "待处理" 
                  : item.status == 2 ? "已处理" 
                  : item.status == 3 ? "已拒绝" 
                  : item.status == 4 ? "已取消" 
                  : item.status == 5 ? "待退货" 
                  : item.status == 6 ? "已拒绝" 
                  : item.status == 7 ? "待退款" 
                  : item.status == 8 ? "已拒绝" 
                  : "-" }}</span>
              </div>
            </div>
            <div class="order_column">
              <div>
                <span class="order_key">订单状态</span>
                <span>{{
                  item.order_status == 1
                    ? "未支付"
                    : item.order_status == 2
                    ? "待发货"
                    : item.order_status == 3
                    ? "待收货"
                    : item.order_status == 4
                    ? "评价"
                    : item.order_status == 5
                    ? "已取消"
                    : item.order_status == 6
                    ? "已完成"
                    : item.order_status == 7
                    ? "支付失败"
                    : item.order_status == 8
                    ? "取消发货"
                    : "-"
                }}</span>
              </div>
              <div>
                <span class="order_key">申请时间</span>
                <span>{{ item.apply_time }} </span>
              </div>
              <div>
                <span class="order_key">退货原因</span>
                <span>{{ item.reason== 1
                    ? "发错货"
                    : item.order_status == 2
                    ? "退运费"
                    : item.order_status == 3
                    ? "质量问题"
                    : item.order_status == 4
                    ? "假冒品牌"
                    : item.order_status == 5
                    ? "我不想要了"
                    : item.order_status == 6
                    ? "商品信息不符"
                    : item.order_status == 7
                    ? "七天无理由"
                    : item.order_status == 8
                    ? "其它"
                    : "-" }} </span>
              </div>
              <div>
                <span class="order_key">退货描述</span>
                <span> {{ item.explain }}</span>
              </div>
            </div>
          </div>
          <div class="Returntoprove">
            <span class="order_key_hei">退货证明</span>
            <div v-for="(src,int) in item.imageArr" :key="int" style="margin-left:30px;">
                <img :src="src" alt=""  style="width: 80px;height: 60px;">
            </div>
          </div>
          </div>
          <div v-if="status==5 || status==2 || status==3 || status==6 || status==8">
            <div  class="order_information" v-for="(item, index) in RefundInformation" :key="index" >
              <div class="order_column">
              <div>
                <span class="order_key">退货单号</span>
                <span>{{ item.express_no }}</span>
              </div>
            </div>
            <div class="order_column">
              <div>
                <span class="order_key">物流公司</span>
                <span>{{ item.express }}</span>
              </div>
            </div>
            <div class="order_column">
              <div>
                <span class="order_key">退货时间</span>
                <span> {{ item.return_time }}</span>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div v-if="status!=='1'">
          <div class="order_information" v-for="(item, index) in RefundInformation" :key="index">
            <div class="order_column">
              <div style="display:flex;align-items: center;">
                <span class="order_key">退货地址</span>
                <span style="width:70%">{{item.receivers_address}}</span>
              </div>
            </div>
            <div class="order_column">
              <div style="display:flex;align-items: center;">
                <span class="order_key">退货联系人</span>
                <span style="width:70%">{{item.receivers_names}}</span>
              </div>
            </div>
            <div class="order_column">
              <div style="display:flex;align-items: center;">
                <span class="order_key">退货联系电话</span>
                <span style="width:70%">{{item.receivers_phone}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 退货信息输入框 -->
        <div v-if="status==1"> 
          <div class="order_information">
            <div class="order_column">
              <div style="display:flex;align-items: center;">
                <span class="order_key">退货地址</span>
                <el-input
                  style="width:70%"
                  type="textarea"
                  autosize
                  placeholder="请输入退货接收详细地址"
                  v-model="returnAddress"
                  maxlength="50">
                </el-input>
              </div>
            </div>
            <div class="order_column">
              <div style="display:flex;align-items: center;">
                <span class="order_key">退货联系人</span>
                <el-input
                  style="width:70%"
                  type="textarea"
                  autosize
                  placeholder="输入联系人"
                  v-model="returnPrepo">
                </el-input>
              </div>
            </div>
            <div class="order_column">
              <div style="display:flex;align-items: center;">
                <span class="order_key">退货联系电话</span>
                <el-input
                  style="width:70%"
                  type="textarea"
                  autosize
                  placeholder="请输入联系人电话"
                  v-model="returnPhone"
                  maxlength="25">
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <!-- 第一次处理意见 -->
        <div class="handlingsuggestion_box"  v-if="status==1">
          <div class="handlingsuggestion_left">处理意见</div>
          <el-input class="handlingsuggestion_right" type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容"
            v-model="textarea" resize="none">
          </el-input>
        </div>
        <!-- 第一次处理之后展示的处理人信息 -->
        <div  v-if="status==5 || status==7 || status == 3  || status == 2 || status==8" >
          <div class="order_information ">
            <div class="order_column">
              <div>
                <span class="order_key">退货申请处理人</span>
                <span style="margin-left:20px">{{waitConfirm_name}}</span>
              </div>
            </div>
            <div class="order_column">
              <div>
                <span class="order_key">处理时间</span>
                <span>{{ waitConfirm_time}}</span>
              </div>
            </div>
            <div class="order_column">
                <span class="order_key">处理意见</span>
                <span> {{ waitConfirm_suggestion }}</span>
            </div>
          </div>
        </div>
        <!-- 第二步所需处理意见 -->
        <div class="handlingsuggestion_box"  v-if="status==5  && express_no">
          <div class="handlingsuggestion_left">处理意见</div>
          <el-input class="handlingsuggestion_right" type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容"
            v-model="textarea" resize="none">
          </el-input>
        </div>
        <div  v-if="status==5  && express_no" class="handlingsuggestion_img" >
          <div class="handlingsuggestion_left">验收照片</div>
          <div class="handlingsuggestion_right" >
            <el-upload action="#"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
            list-type="picture-card"
            :auto-upload="false"
            :file-list="imgUpdataList"
            :class="imgUpdataList.length == 1 ? 'mf' : ''"
            :on-change="(file, fileList) => handleChange(file, fileList, 0)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 0)" >
            <i slot="default"
               class="el-icon-plus"></i>
          </el-upload>
          </div>
        </div>
        <div  v-if="status==7 || status==2 || status==8 || status == 3 " >
          <div class="order_information ">
            <div class="order_column">
              <div>
                <span class="order_key">退货验收处理人</span>
                <span style="margin-left:20px">{{ confirm_name }}</span>
              </div>
            </div>
            <div class="order_column">
              <div>
                <span class="order_key">处理时间</span>
                <span>{{ confirm_time }}</span>
              </div>
            </div>
            <div class="order_column">
                <span class="order_key">处理意见</span>
                <span> {{ confirm_suggestion }}</span>
            </div>
          </div>
        </div>
        <div v-if="status==7 || status == 2 || status==8 || status == 3 " class="Returntoprove">
          <span class="order_key_hei">附件</span>
          <div class="handlingsuggestion_right">
            <span v-for="(item) in  accep_photo" :key="item" style="margin-left:30px">
                <img :src="item" alt=""  style="width: 80px;height: 60px;">
            </span>
          </div>
        </div>
        <div  v-if=" status == 3  || status == 2 || status==8" >
          <div class="order_information ">
            <div class="order_column">
              <div>
                <span class="order_key">退款处理人</span>
                <span style="margin-left:20px">{{ handling_name }}</span>
              </div>
            </div>
            <div class="order_column">
              <div>
                <span class="order_key">处理时间</span>
                <span>{{ handling_time }}</span>
              </div>
            </div>
            <div class="order_column">
                <span class="order_key">处理意见</span>
                <span> {{ handling_suggestion }}</span>
            </div>
          </div>
        </div>
        <div class="handlingsuggestion_box"  v-if="status==7">
          <div class="handlingsuggestion_left">处理意见</div>
          <el-input class="handlingsuggestion_right" type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容"
            v-model="textarea" resize="none">
          </el-input>
        </div>
      </div>
      <div class="RefunDetail" v-if="status==1" >
        <span class="RefunDetail_quest" @click="getSurerefund(5)">同意退货</span>
        <span class="RefunDetail_delet" @click="getDeletSurerefund(6)">拒绝退货</span>
      </div>
      <div class="RefunDetail" v-if="status==5 && express_no">
        <span class="RefunDetail_quest" @click="getTwoWatiReturn(7)">同意退货</span>
        <span class="RefunDetail_delet" @click="getTwoDeletgetTwoWatiReturn(8)">拒绝退货</span>
      </div>
      <div class="RefunDetail" v-if="status==7 && express_no" >
        <span class="RefunDetail_quest" @click="RefundReturn(3)">同意退款</span>
        <span class="RefunDetail_delet" @click="NoRefundReturn(4)">拒绝退款</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      orderinformation: [], //退款商品信息
      orderRowinfo: [], //商品的规格
      RefundInformation: [], //退款申请单信息
      payStatus: 1, // 0:现金和优惠券；1:全部优惠券；2:全现金
      orderCode: 1, // 订单号
      cardId: 1, //订单使用的购物卡卡号，订单最外层的 card_id 字段
      priceCard: 1, // 主订单退款，传最外层的 price_card 店铺订单退款，传店铺层的 price_card_pla; 店铺下商品退款，传商品层的 price_card_pla
      priceAccount: 1, // 余额支付金额，订单层的 price_account
      orderLevel:2, // 订单号等级，1-主订单 2-商家订单 3-商品订单
      applyRefundId: 1, //其他平台退款申请Id  必填
      transactionId: 1, // 支付系统种订单Id  选填
      payId: 1, // 其他平台订单Id，必填
      refundMoney: 1, //退款金额
      subsidyMoney: 1, //需要退的补差金额 默认为0
      yMoney:0, //需要退的分佣 默认为0
      refunds_id:"",//退款主键自增id
      handling_time:'',//处理时间
      handling_suggestion:'',//处理意见
      handling_name:'',//处理人名称
      uid:'',//用户的id
      textarea:"",//处理意见
      status:"",//订单的状态
      company_name:"",//当前用户的处理人名称
      returnPhone:"",//退货人联系方式
      returnPrepo:"",//退货人联系姓名
      returnAddress:"",//退货人地址
      confirm_uid:"",//第一次处理之后返回的uid
      updataimg:[],//上传照片的数组
      imgUpdataList:[],//选择图片的上传的数组
      confirm_name:"",//第二次处理人的名字
      confirm_suggestion:"",//第二次处理人的意见
      confirm_time:"",//第二次处理人的时间
      accep_photo:[],//验收的上传照片
      receivers_phone:"", //退货联系方式
      receivers_names:"", //退货名字
      receivers_address:"", //退货详细地址
      express_no:"",//是否有退货单号
      waitConfirm_time :"",
      waitConfirm_suggestion :"",
      waitConfirm_name:"",
    };
  },
  created() {
    this.status=this.$route.query.status
  },
  mounted() {
    this.getRefunDetail(this.$route.query.orderChildGoodsSn);
    // this.status=this.$route.query.status
    this.company_name=JSON.parse(localStorage.getItem("vuex")).userInfo.company_name? JSON.parse(localStorage.getItem("vuex")).userInfo.company_name:'-'
  },
  computed:{
  },
  methods: {
    ...mapActions({
      QueryRefundConcet: "commodity/QueryRefundConcet", //获取详情的接口
      OneAgreeReturn: "commodity/OneAgreeReturn", //第一次同意退款接口
      OneRefusedReturn:"commodity/OneRefusedReturn",//第一次退款北京接口
      TwoRefundsWatiReturn: "commodity/TwoRefundsWatiReturn", //第二次同意退款接口
      TwoUpRefundsWatiReturn:"commodity/TwoUpRefundsWatiReturn",//第二次退款北京接口
      uploadFile: "commodity/uploadFile", //  图片上传
      Surerefund: "commodity/Surerefund", //同意退款接口
      Drawback:"commodity/Drawback",//退款北京接口
    }),
    RefundReturn(num){ //同意退货之后退款
      let params = {
        token: this.$store.state.token,
        payStatus:this.payStatus, // 0:现金和优惠券；1:全部优惠券；2:全现金
        orderCode:this.orderCode, // 订单号
        cardId:this.cardId, //订单使用的购物卡卡号，订单最外层的 card_id 字段
        priceCard:this.priceCard, // 主订单退款，传最外层的 price_card 店铺订单退款，传店铺层的 price_card_pla; 店铺下商品退款，传商品层的 price_card_pla
        priceAccount: this.priceAccount, // 余额支付金额，订单层的 price_account
        orderLevel:this.orderLevel, // 订单号等级，1-主订单 2-商家订单 3-商品订单
        applyRefundId:this.applyRefundId, //其他平台退款申请Id  必填
        payId: this.payId, // 其他平台订单Id，必填
        refundMoney:this.refundMoney, //退款金额
        subsidyMoney:this.subsidyMoney, //需要退的补差金额 默认为0
        yMoney:this.yMoney, //需要退的分佣 默认为0
        uid:this.uid,//用户的id
      };
      this.Surerefund(params).then((res) => {
        if (res.code === 1) {
          if(!this.textarea){
            return this.$message.error('请输入处理意见');
          }
          let data={
            refunds_id:this.refunds_id,
            refunds_status:num,
            handling_suggestion:this.textarea,
            handling_uid:sessionStorage.getItem("unified_id"),
            handling_name:this.company_name
          }
          this.Drawback(data).then(reserve => {
            if(reserve.code===0){
              this.$router.go(-1);
            }else{
              this.$message.error(reserve.msg);
            }
          })
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    NoRefundReturn(num){ //拒绝退货之后退款
      if(!this.textarea){
        return this.$message.error('请输入处理意见');
      }
      let data={
          refunds_id:this.refunds_id,
          refunds_status:num,
          handling_suggestion:this.textarea,
          handling_uid:sessionStorage.getItem("unified_id"),
          handling_name:this.company_name
        }
        this.Drawback(data).then(reserve => {
            if(reserve.code===0){
              this.$router.go(-1);
            }else{
              this.$message.error(reserve.msg);
            }
        })
    },
    handleChange (file, fileList, index, talent_id) { //上传图片
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          this.$message.success("上传成功！");
          this.updataimg.push( res.data.formdata_details[0].urls)
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    handleRemove (file, fileList, index, talent_id) { //删除图片
      this.updataimg.splice(index,1)
    },
    getTwoWatiReturn(num){//第二次同意退货的事件
      let params = {
        confirm_suggestion:this.textarea,
        confirm_name: this.waitConfirm_name,
        confirm_uid: this.confirm_uid,
        accep_photo: this.updataimg.toString(),
        refunds_id: this.refunds_id,
        refunds_status:num,
      }
      this.TwoRefundsWatiReturn(params).then((res) => {
        if (res.code === 0) {
          this.$router.go(-1);
        } else {
          this.$message.error(res.msg);
        } 
      });
    },
    getTwoDeletgetTwoWatiReturn(num){//第二次取消退货的事件
      if(!this.textarea){
        return this.$message.error('请输入处理意见');
      }else if(this.updataimg.length<=0){
        return this.$message.error('请选择图片进行上传');
      }
       let params = {
        confirm_suggestion:this.textarea,
        confirm_name: this.waitConfirm_name,
        confirm_uid: this.confirm_uid,
        accep_photo: this.updataimg.toString(),
        refunds_id: this.refunds_id,
        refunds_status:num,
      }
      this.TwoUpRefundsWatiReturn(params).then((res) => {
        if (res.code === 0) {
          this.$router.go(-1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getDeletSurerefund(num){ //第一次取消退款的事件
      if(!this.returnAddress){
        return this.$message.error('请输入退货地址');
      }else if(!this.returnPrepo){
        return this.$message.error('请输入退货联系人');
      }else if(!this.returnPhone){
        return this.$message.error('请输入退货联系电话');
      } else if(!this.textarea){
        return this.$message.error('请输入处理意见');
      }
      let data={
        receivers_names:this.returnPrepo,
        receivers_phone:this.returnPhone,
        receivers_address:this.returnAddress,
        waitConfirm_suggestion:this.textarea,
        refunds_id:this.refunds_id,
        refunds_status:num,
        waitConfirm_name:this.company_name,
        waitConfirm_uid:sessionStorage.getItem("unified_id"),
      };
        this.OneRefusedReturn(data).then(reserve => {
            if(reserve.code==0){
              this.$router.go(-1);
            }else{
              this.$message.error(reserve.msg);
            }
        })
    },
    getSurerefund(num) {//第一次同意退货的事件
      if(!this.returnAddress){
        return this.$message.error('请输入退货地址');
      }else if(!this.returnPrepo){
        return this.$message.error('请输入退货联系人');
      }else if(!this.returnPhone){
        return this.$message.error('请输入退货联系电话');
      } else if(!this.textarea){
        return this.$message.error('请输入处理意见');
      }
      let params = {
        receivers_names:this.returnPrepo,
        receivers_phone:this.returnPhone,
        receivers_address:this.returnAddress,
        waitConfirm_suggestion:this.textarea,
        refunds_id:this.refunds_id,
        refunds_status:num,
        waitConfirm_name:this.company_name,
        waitConfirm_uid:sessionStorage.getItem("unified_id"),
      };
      this.OneAgreeReturn(params).then((res) => {
        if (res.code === 0) {
          this.$router.go(-1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getRefunDetail(orderChildGoodsSn) { //查询退货详情
      let params = {
        server_number: orderChildGoodsSn,
      };
      this.QueryRefundConcet(params).then((res) => {
        if (res.code == 0) {
          this.orderinformation = res.data.goodlist;
          this.payStatus = res.data.pay_status
          this.refunds_id=res.data.refundList[0].id
          this.orderCode = res.data.refundList[0].order_child_goods_sn
          this.cardId = res.data.cardrefund.card_id
          this.priceCard = res.data.cardrefund.price_card
          this.priceAccount = res.data.cardrefund.price_account
          this.orderLevel = res.data.cardrefund.order_level
          this.applyRefundId = res.data.applyrefund.applyRefundId
          this.payId = res.data.applyrefund.payId
          this.refundMoney =  res.data.applyrefund.refundMoney
          this.subsidyMoney = res.data.applyrefund.subsidyMoney
          this.yMoney = res.data.applyrefund.yMoney
          this.uid=res.data.cardrefund.uid
          this.waitConfirm_time = res.data.refundList[0].waitConfirm_time
          this.waitConfirm_suggestion = res.data.refundList[0].waitConfirm_suggestion
          this.waitConfirm_name = res.data.refundList[0].waitConfirm_name
          this.handling_time = res.data.refundList[0].handling_time
          this.handling_suggestion = res.data.refundList[0].handling_suggestion
          this.handling_name = res.data.refundList[0].handling_name
          this.confirm_uid = res.data.refundList[0].waitConfirm_uid
          this.confirm_name =  res.data.refundList[0].confirm_name
          this.confirm_suggestion =  res.data.refundList[0].confirm_suggestion
          this.confirm_time =  res.data.refundList[0].confirm_time
          this.accep_photo =  res.data.refundList[0].accep_photo
          this.express_no= res.data.refundList[0].express_no?true:false
          let arr = [];
          res.data.goodlist.forEach((element) => {
            if (element.json) {
              let iten = JSON.parse(element.json);
              arr.push(iten.goods_attributes);
            }
          });
          this.orderRowinfo = arr.flat(Infinity);
          res.data.refundList.forEach(item => {
            let reg = /^(.{3}).*(.{4})$/
            item.user_name=item.user_name.replace(reg, '$1****$2')
          })
          this.RefundInformation = res.data.refundList;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getummaries(param) {
      //订单明细的合计方法
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0 || index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 6) {
          sums[index] = "合计 :";
          return;
        }
        const values = data.map((item) => {
          if (column.property === "price_pay") {
            return Number(item[column.property]);
          }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = String(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "  ";
        } else {
          sums[index] = " ";
        }
      });
      this.$nextTick(() => {
        //合并订单吗清晰最后一行
        if (this.$refs.table.$el) {
          var current = this.$refs.table.$el.querySelector(".el-table__footer-wrapper").querySelector(".el-table__footer");
          var tds = current.rows[0].cells;
          tds[0].colSpan = "9"; // 前四行都显示累计
          tds[0].style.textAlign = "right"; // 前四行都显示累计
          tds[0].style.paddingRight = "20px";
          tds[1].style.display = "none";
          tds[2].style.display = "none";
          tds[3].style.display = "none";
          tds[4].style.display = "none";
          tds[5].style.display = "none";
          tds[6].style.display = "none";
          tds[7].style.display = "none";
          tds[8].style.display = "none";
        }
      });
      return sums;
    },
  },
};
</script>

<style  lang="scss" scoped>
.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  font-size: 18px;
  color: #333;
  padding: 15px 32px;
}
.order_Box {
  // width: 100%;
  background-color: #fff;
  margin: 24px 24px 0 24px;
  padding: 20px 30px;
  .Returntoprove{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    padding-top: 20px;
    .order_key_hei{
        width: 100px;
        line-height: 80px;
        height: 80px;
        text-align: center;
        display: inline-block;
        .order_hei_item{
            width: 80px;
            height: 60px;
            margin-left: 30px;
        }
      }
  }
  .order_information {
    display: flex;
    justify-content: flex-start;
    background: #fff;
    width: 100%;
    padding-left: 20px;
    padding-top: 20px;
    // box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    .order_column {
      flex: 1;
      line-height: 50px;
      .order_key {
        width: 100px;
        text-align: center;
        display: inline-block;
      }
      
    }
  }
}
.handlingsuggestion_img{
  display: flex;
  justify-content: flex-start;
  align-content: center;
  .handlingsuggestion_left{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align:center;
    background-color: rgb(245, 246, 250);
    border-top: 1px solid #C0C4CC;
    border-left: 1px solid #C0C4CC;
    border-bottom: 1px solid #C0C4CC;
    border-radius: 2px;
  }
  .handlingsuggestion_right{
    flex: 5;
  }
}
.handlingsuggestion_box{
  margin: 24px 0;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  .handlingsuggestion_left{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align:center;
    background-color: rgb(245, 246, 250);
    border-top: 1px solid #C0C4CC;
    border-left: 1px solid #C0C4CC;
    border-bottom: 1px solid #C0C4CC;
    border-radius: 2px;
  }
  .handlingsuggestion_right{
    flex: 5;
  }
}
.RefunDetail{
  // width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 20px 30px;
  margin: 0 24px 0 24px;
  display: flex;
  justify-content:space-around;
  .RefunDetail_quest{
    color: #fff;
    background-color: rgba(3, 157, 18, 1);
    width:200px;
    height: 50px;
    border-radius:8px;
    font-size: 18px;
    text-align: center;
    line-height:50px;
  }
  .RefunDetail_delet{
    color: #fff;
    background-color:red;
    width:200px;
    height: 50px;
    border-radius:8px;
    font-size: 18px;
    text-align: center;
    line-height:50px;
  }
}
.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
.accessory_box{
  display: flex;
  justify-content: flex-start;
  align-content: center;
  .accessory_left{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align:center;
  }
  .handlingsuggestion_right{
    flex: 5;
  }
}
</style>